import { OrganizationNode } from '@/types/Organizations';
import { Box, Button } from '@palmetto/palmetto-components';
import { ReactNode } from 'react';

interface OrganizationSettingsCardHeaderProps {
  isPhone?: boolean;
  organization?: OrganizationNode | undefined;
  onClick?: () => void;
  cardTitle: string;
  subtitle?: ReactNode;
  isInherited?: boolean;
  editButtonLabel?: string;
  renderEditButton?: (button: ReactNode) => ReactNode;
}

export const OrganizationSettingsCardHeader = ({
  organization,
  isPhone,
  cardTitle,
  subtitle,
  isInherited,
  onClick,
  editButtonLabel = 'Edit',
  renderEditButton,
}: OrganizationSettingsCardHeaderProps) => {
  const editButton = organization ? (
    <Button
      variant="secondary"
      tone="neutral"
      size="sm"
      aria-label={`Edit ${cardTitle}`}
      iconPrefix="pencil"
      onClick={onClick}
    >
      {!isPhone && editButtonLabel}
    </Button>
  ) : null;

  return (
    <Box padding="lg" direction="row" justifyContent="space-between" alignItems="flex-start">
      <Box direction="column" childGap="2xs">
        <Box as="h3" fontWeight="medium" fontSize="md">
          {cardTitle}
        </Box>
        {subtitle}
      </Box>
      {isInherited && <Box style={{ flex: '1', alignItems: 'center' }}>Settings are inherited from Parent</Box>}
      {renderEditButton ? renderEditButton(editButton) : editButton}
    </Box>
  );
};
